<template>
  <el-dialog
    :visible="visible"
    :title="$t('CargoMsg.Cargo_Appoint2')"
    :before-close="cancel"
    width="650px"
    append-to-body
    class="rule-configuration-dialog"
  >
    <div style="display: flex; margin: 10px">
      <el-button style="margin-left: 450px" type="danger" @click="onDel(null)">{{ $t('Menu.delete') }}</el-button>
    </div>
    <div class="grid">
      <cargo-ag-grid
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :row-data="rowData"
        :show-side-bar="false"
        style="height:100%;min-height: 340px;"
        @rowDataChanged="rowDataChanged"
      />
    </div>
    <template slot="footer">
      <div>
        <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import { deepClone } from '@/utils'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import { DocumentManage } from '@/utils/commonUtil'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
export default {
  name: 'RuleConfigurationDialog',
  components: { CargoAgGrid, cargoAdvanceSelect },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    appoints: {
      type: Array,
      default: () => []
    },
    workflow: {
      type: Object,
      default: () => {}
    },
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      rowData: [],
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      selectedRows: null,
      displayName: '',
      gridApi: null,
      loading: null,
      gridOptions: {
        rowSelection: 'multiple',
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        },
        onSortChanged: this.rowDataChanged
      },
      editable: true,
      selectedData: null,
      selectedBak: '',
      ruleConditions: Array.from(WorkflowConstants.RULE_CONDITIONS),
      documentManage: new DocumentManage()
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          headerCheckboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_Approver'),
          field: 'fromUserId',
          suppressMenu: true,
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'chineseName',
              selectType: TYPE_NAMES.basic_data_User,
              methodParams: { category: 'role', shape: '' },
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value',
              filterable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Appointer'),
          field: 'toUserId',
          suppressMenu: true,
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'chineseName',
              selectType: TYPE_NAMES.basic_data_User,
              methodParams: { category: 'role', shape: '' },
              callbackParams: { key: 'userId' },
              callbackMethodType: 'value',
              filterable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 140,
          cellRenderer: params => {
            const onAdd = this.documentManage.getPath('onAdd')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onDel}(${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }]
    }
  },
  watch: {
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function() {
      context.onAdd()
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.rowData = deepClone(this.appoints)
      if (!this.rowData || this.rowData.length === 0) {
        this.rowData = []
        this.onAdd()
      } else {
        ColumnUtils.addSerialNumber(this.rowData)
      }
    },
    onAdd() {
      const newConfiguration = {
        fromUserId: null,
        toUserId: null,
        id: 'serialNumber_' + this.rowData.length
      }
      this.rowData.push(newConfiguration)
      ColumnUtils.addSerialNumber(this.rowData)
    },
    onDel(serialNumber) {
      if (serialNumber !== null) {
        this.rowData = this.rowData.filter(row => row.serialNumber !== serialNumber)
      } else {
        const api = this.gridOptions.api
        const selRows = api.getSelectedRows() // 获取选中的行
        api.updateRowData({ remove: selRows })
        const rowData = []
        api.forEachNode(node => rowData.push(node.data))
        this.rowData = rowData
      }
      if (this.rowData.length === 0) {
        this.onAdd()
      } else {
        ColumnUtils.addSerialNumber(this.rowData)
      }
    },
    onSave() {
      if (this.checkData()) {
        return
      }
      this.$emit('change', this.rowData)
      this.cancel()
    },
    cancel() {
      this.$emit('close')
    },
    // 重复数据校验
    checkData() {
      if (this.rowData.length === 1) {
        if (!this.rowData[0].fromUserId && !this.rowData[0].toUserId) {
          return false
        }
      }
      // 一个人只能作为【审批人】或者【委派人】
      // 【审批人】->【委派人】 一对一
      // 【委派人】->【审批人】 一对多
      const fromUserIds = []
      const toUserIds = []
      for (const data of this.rowData) {
        if (!data.fromUserId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ApproverNotEmpty'))
          return true
        }
        if (!data.toUserId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AppointerNotEmpty'))
          return true
        }
        if (fromUserIds.indexOf(data.fromUserId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ApproverRepeat'))
          return true
        }
        if (toUserIds.indexOf(data.fromUserId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ApproverAndAppointerRepeat'))
          return true
        }
        fromUserIds.push(data.fromUserId)
        if (fromUserIds.indexOf(data.toUserId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ApproverAndAppointerRepeat'))
          return true
        }
        toUserIds.push(data.toUserId)
      }
      return false
    },
    rowDataChanged(params) {
      ColumnUtils.sortChanged(params, this.columnDefs, this.rowData)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.rule-configuration-dialog{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    /deep/.el-select {
      width: 100%;
    }
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}

</style>
